import { userService } from '../services/users';
import { history } from '../helpers/history';
import { alertActions } from './alerts';
import authHeader from '../helpers/authHeader';
import handleErrors from '../helpers/handleErrors';

const ROOT_URL = '/api';

//Sign In User
export const SIGNIN_USER = 'SIGNIN_USER';
export const SIGNIN_USER_REQUESTED = 'SIGNIN_USER_REQUESTED';
export const SIGNIN_USER_SUCCESS = 'SIGNIN_USER_SUCCESS';
export const SIGNIN_USER_FAILURE = 'SIGNIN_USER_FAILURE';
export const SIGNOUT_USER = 'SIGNOUT_USER';

export const ME_FROM_TOKEN = 'ME_FROM_TOKEN';
export const ME_FROM_TOKEN_REQUESTED = 'ME_FROM_TOKEN_REQUESTED';
export const ME_FROM_TOKEN_SUCCESS = 'ME_FROM_TOKEN_SUCCESS';
export const ME_FROM_TOKEN_FAILURE = 'ME_FROM_TOKEN_FAILURE';

export const UPDATE_USER = 'UPDATE_USER';
export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS';
export const UPDATE_USER_FAILURE = 'UPDATE_USER_FAILURE';

export const AUTHENTICATE_WITH_TOKEN = 'AUTHENTICATE_WITH_TOKEN';
export const AUTHENTICATE_WITH_TOKEN_REQUESTED = 'AUTHENTICATE_WITH_TOKEN_REQUESTED';
export const AUTHENTICATE_WITH_TOKEN_SUCCESS = 'AUTHENTICATE_WITH_TOKEN_SUCCESS';
export const AUTHENTICATE_WITH_TOKEN_FAILURE = 'AUTHENTICATE_WITH_TOKEN_FAILURE';

export const REGISTER = 'REGISTER';
export const REGISTER_REQUESTED = 'REGISTER_REQUESTED';
export const REGISTER_SUCCESS = 'REGISTER_SUCCESS';
export const REGISTER_FAILURE = 'REGISTER_FAILURE';

export const RESET_PASSWORD = 'RESET_PASSWORD';
export const RESET_PASSWORD_REQUESTED = 'RESET_PASSWORD_REQUESTED';
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';
export const RESET_PASSWORD_FAILURE = 'RESET_PASSWORD_FAILURE';

export const userActions = {
	signInUser,
	signInUserRequested,
	signInUserSuccess,
	signInUserFailure,
	signOutUser,
	meFromToken,
	meFromTokenRequested,
	meFromTokenSuccess,
	meFromTokenFailure,
	updateUser,
	updateUserSuccess,
	updateUserFailure,
	adminUpdateUser,
	authenticateWithToken,
	authenticateWithTokenRequested,
	authenticateWithTokenSuccess,
	authenticateWithTokenFailure,
	register,
	registerRequested,
	registerSuccess,
	registerFailure,
	resetPassword,
	resetPasswordRequested,
	resetPasswordSuccess,
	resetPasswordFailure
}

function signInUser(formValues) {
	return (dispatch) => {
		dispatch(signInUserRequested());
		userService.signin(formValues)
			.then(
				res => {
					dispatch(signInUserSuccess(res.auth_token, res.user));
					if (res.user.role === 'admin') {
						history.push('/host/admin/events');
					} else if (res.user.role === 'host') {
						history.push('/host/hub/dashboard');
					}
				},
				error => {
					dispatch(signInUserFailure(error));
					dispatch(alertActions.error(error));
				}
			);
	}
}

function signInUserRequested() {
	return {
    type: SIGNIN_USER_REQUESTED,
  };
}

function signInUserSuccess(token, user) {
	return {
    type: SIGNIN_USER_SUCCESS,
    token,
    user
  };
}

function signInUserFailure(error) {
  return {
    type: SIGNIN_USER_FAILURE,
    error
  };
}

function signOutUser() {
	userService.signout()
	return {
    type: SIGNIN_USER,
  };
}

function meFromToken() {
	return (dispatch) => {
		dispatch(meFromTokenRequested());
		userService.getUserFromToken()
			.then(
				res => {
					dispatch(meFromTokenSuccess(res.user));
				},
				error => {
					dispatch(meFromTokenFailure(error));
					dispatch(alertActions.error(error));
				}
			);
	}
}

function meFromTokenRequested() {
	return {
    type: ME_FROM_TOKEN_REQUESTED,
  };
}

function meFromTokenSuccess(user) {
	return {
    type: ME_FROM_TOKEN_SUCCESS,
    user
  };
}

function meFromTokenFailure(error) {
  return {
    type: ME_FROM_TOKEN_FAILURE,
    error
  };
}

function updateUser(user) {
	return (dispatch) => {
		const requestOptions = {
	    body: JSON.stringify({ user: user }),
      credentials: 'same-origin',
      headers: authHeader(),
      method: 'PUT',
	  };

		return fetch(ROOT_URL + `/users/${user.id}`, requestOptions)
			.then(handleErrors)
			.then(res => res.json())
			.then(res => {
				console.log("We are succeeding in updatedUser?????? whyyyyyyyy", res)
				dispatch(updateUserSuccess(res));
				dispatch(alertActions.success('Changes saved successfully'));
			})
			.catch(error => {
				console.log("ARE WE FAILING IN updatedUser??????", error)
				dispatch(updateUserFailure(error));
				dispatch(alertActions.error(error));
			});
	}
}

function adminUpdateUser(user) {
	return (dispatch) => {
		const requestOptions = {
	    body: JSON.stringify({ user: user }),
      credentials: 'same-origin',
      headers: authHeader(),
      method: 'PUT',
	  };

		return fetch(ROOT_URL + `/admin/users/${user.id}`, requestOptions)
			.then(handleErrors)
			.then(res => res.json())
			.then(res => {
				dispatch(alertActions.success('Changes saved successfully'));
			})
			.catch(error => {
				dispatch(updateUserFailure(error));
				dispatch(alertActions.error(error));
			});
	}
}

function updateUserSuccess(updatedUser) {
	return {
    type: UPDATE_USER_SUCCESS,
    updatedUser
  };
}

function updateUserFailure(error) {
	return {
    type: UPDATE_USER_FAILURE,
    error
  };
}

function authenticateWithToken(token) {
	return (dispatch) => {
		dispatch(authenticateWithTokenRequested());
		userService.authenticateWithToken(token)
			.then(
				res => {
					dispatch(authenticateWithTokenSuccess(res.user));
					if (res.user.role === 'admin') {
						history.push('/host/admin/events');
					} else if (res.user.role === 'host') {
						if ((!res.user.firstname || res.user.firstname === '') && (!res.user.lastname || res.user.lastname === '')) {
							history.push('/host/hub/forms/profile');	
						} else {
							history.push('/host/hub/dashboard');
						}
					}
				},
				error => {
					dispatch(authenticateWithTokenFailure(error));
					dispatch(alertActions.error(error));
				}
			);
	}
}

function authenticateWithTokenRequested() {
	return {
    type: AUTHENTICATE_WITH_TOKEN_REQUESTED,
  };
}

function authenticateWithTokenSuccess(user) {
	return {
    type: AUTHENTICATE_WITH_TOKEN_SUCCESS,
    user
  };
}

function authenticateWithTokenFailure(error) {
  return {
    type: AUTHENTICATE_WITH_TOKEN_FAILURE,
    error
  };
}

function register(email, password) {
	return (dispatch) => {
		dispatch(registerRequested());
		userService.register(email, password)
			.then(
				res => {
					dispatch(registerSuccess());
					// since we're inside an iframe:
					window.top.location.href = '/host/signin/' + res.login_token.token;
				},
				error => {
					dispatch(registerFailure(error));
					dispatch(alertActions.error(error));
				}
			);
	}
}

function registerRequested() {
	return {
    type: REGISTER_REQUESTED,
  };
}

function registerSuccess(user) {
	return {
    type: REGISTER_SUCCESS,
  };
}

function registerFailure(error) {
  return {
    type: REGISTER_FAILURE,
    error
  };
}

function resetPassword(email) {
	return (dispatch) => {
		dispatch(resetPasswordRequested());
		userService.resetPassword(email)
			.then(
				res => {
					dispatch(resetPasswordSuccess());
					history.push('/host/reset-password-success');
				},
				error => {
					dispatch(resetPasswordFailure(error));
					dispatch(alertActions.error(error));
				}
			);
	}
}

function resetPasswordRequested() {
	return {
    type: RESET_PASSWORD_REQUESTED,
  };
}

function resetPasswordSuccess(user) {
	return {
    type: RESET_PASSWORD_SUCCESS,
  };
}

function resetPasswordFailure(error) {
  return {
    type: RESET_PASSWORD_FAILURE,
    error
  };
}
